module.exports = __webpack_public_path__ + "static/img/carousel_1_quelbo_ar_16_9_w_2400.6b7aabf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_1_quelbo_ar_16_9_w_2400.jpg
// module id = Qq9q
// module chunks = 0